// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__u7KON","active":"style_active__X0uJe","paymentSucessInner":"style_paymentSucessInner__V9ctZ","SuccBtn":"style_SuccBtn__8xchA"};